import React from "react";
import {Navigate} from "react-router-dom";
import { useTranslation } from 'react-i18next'

import {Button} from "components/form";
import LinkExpiredImg from 'assets/images/svg/link_expired_art.svg'
import { useResendEmailToken } from "pages/informations/info.service";

const LinkExpiredPage = () => {
    const { t } = useTranslation()
    const { handleResendEmailCode,isStillBlocked,isStillValid,routeState ,isLoading} = useResendEmailToken();

    if(isStillValid) return <Navigate to='/info/link-sent' state={routeState} />;
    if(isStillBlocked) return <Navigate to='/info/blocked-email' state={routeState} />;

    return (
        <div className="registration link-send">
            <div className="row">
                <div className="col-lg-8 col-md-12 mx-auto">
                    <div className="row">
                        <div className="col-lg-6 col-md-4">
                            <img className="background" src={LinkExpiredImg} alt="background" />
                        </div>
                        <div className="col-lg-6 col-md-8">
                            <div className="box-linksend">
                                <h1>{t('links:exTitle')}</h1>
                                <p>{t('links:exContent')}</p>
                                <Button isLoading={isLoading}  onClick={handleResendEmailCode} className="btn-blue">
                                    {t('links:exResand')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LinkExpiredPage
